import { useMutation } from 'react-query'
import { printItemsSummaryReport, PrintItemsSummaryRequest } from './reportApi'

export const usePrintItemsSummaryReport = () => {
  return useMutation({
    mutationFn: (request: PrintItemsSummaryRequest) => printItemsSummaryReport(request),
  })
}
